import { connect } from "react-redux"
import ImageCollageWidget from "QuorumGrassroots/widgets/ImageCollage/components/index"
import { fullWidthWidgetConnection } from "QuorumGrassroots/widgets/selectors"

export default connect(fullWidthWidgetConnection, null)(ImageCollageWidget)
